import field from './field.js';

const FIRST_ENABLED = 1;		// setCursor() modes
const FIRST_TEXT = 2;
const FIRST_EMPTY = 3;
const FIRST_ERROR = 4;

const setCursorHelper = function(field, where)
{

	let node = document.querySelector(field.selector);

	let is_element_on_screen = node != null;

	if (!is_element_on_screen)
		return;

	let is_element_disabled = node.hasAttribute('disabled');

	if (is_element_disabled)
		return;

	let is_element_hidden = node.type == 'hidden';

	if (is_element_hidden)
		return;

	let is_multiple = (node.type && node.type.match(/checkbox|radio/i));
	let is_mult_compatible = (where == FIRST_ENABLED || where == FIRST_ERROR);

	if (is_multiple && !is_mult_compatible)		// Checkbox/radio vs ENABLED/ERROR
		return;

	let is_not_input = node.nodeName.match(/select|button/i);
	let is_text_compatible = (where != FIRST_TEXT);

	if (is_not_input && !is_text_compatible)	// Select/button vs TEXT
		return;

	let is_error_requested = where == FIRST_ERROR;
	let is_error_flagged = field.getErrorState();

	if (is_error_requested && !is_error_flagged)
		return;

	let is_empty_requested = where === FIRST_EMPTY;
	let is_value_empty = node.value && node.value.length == 0;

	if (is_empty_requested && !is_value_empty)
		return;

	if (node.focus)
		node.focus();

	if (node.select)
		node.select();

	return true;

};

const forEachField = function(form, callback, field_criteria = {})		// field_criteria: {initial_id, final_id, skip_list}
{

	let field_ids = Object.keys(form.fields);

	let first_index = field_criteria.initial_id ? field_ids.indexOf(field_criteria.initial_id) : 0;

	let last_index = field_ids.indexOf(field_criteria.final_id, first_index);

	if (last_index < 0)
		last_index = field_ids.length - 1;

	let skip_list = field_criteria.skip_list || [];

	for (let index = first_index; index <= last_index; index++)
	{

		let in_skip_list = skip_list.indexOf(field_ids[index]) >= 0;

		if (in_skip_list)
			continue;
		
		let field_id = field_ids[index];
		let field = form.fields[field_id];
		let result = callback(field);

		if (result === true)
			break;
		
	}

};

const form = {

	selector: null,
	fields: null,
	callback: null,

	create(properties, fields, callback)		// properties: { selector, init, check, error, submit }, fields: [ { 'properties': {}, 'types': [] }, ... ]
	{
		let form = Object.assign(Object.create(this), properties);
		form.fields = Object.create({});
		form.callback = callback;
		fields.forEach(entry =>
		{
			form.insertOrUpdateField(field.create(Object.assign(entry.properties, { form: form }), entry?.types));
		});
		return form;
	},

	insertOrUpdateField(field)
	{
		this.fields[field.getId()] = field;
	},

	deleteField(id)
	{
		delete this.fields[id];
	},

	getFieldById(id)
	{
		return this.fields[id];
	},

	getFieldByName(name)
	{
		let ids = Object.keys(this.fields);
		let idOrUndefined = ids.find(id => id.split('.')[1] == name);
		return this.fields[idOrUndefined];
	},

	getFieldBySelector(selector)
	{
		let ids = Object.keys(this.fields);
		let regex = new RegExp(`(^|\\b|\\s)${selector}(\\s|\\b|$)`);		// Matches the entire word in the beginning, middle or end of string
		let idOrUndefined = ids.find(id => regex.test(this.fields[id].selector));
		return this.fields[idOrUndefined];
	},

	replaceFieldId(old_id, new_id)
	{
		if (old_id != new_id && this.fields[old_id] && !this.fields[new_id])
		{
			this.fields[new_id] = this.fields[old_id];
			delete this.fields[old_id];
		}
	},

	captureFormEvents()
	{
		document.querySelector(this.selector).addEventListener('submit', this.submit.bind(this));
	},

	releaseFormEvents()
	{
		node = document.querySelector(this.selector);
		node.replaceWith(node.cloneNode(true));
	},

	captureFieldEvents(field_criteria)
	{
		forEachField(this, field => field.captureEvents(), field_criteria);
	},

	releaseFieldEvents(field_criteria)
	{
		forEachField(this, field => field.releaseEvents(), field_criteria);
	},

	setTabOrder(index = 1, field_criteria)
	{
		const callback = (field) =>
		{
			let node = document.querySelector(field.selector);
			if (node)
			{
				node.tabIndex = index++;
			}
		}
		forEachField(this, callback, ffield_criteria);
	},

	setCursor(where, initial_field_id)
	{
		forEachField(this, field => setCursorHelper(field, where), { 'initial_id': initial_field_id });
	},

	setReadOnly(field_criteria)
	{
		forEachField(this, field => field.setReadOnly(), field_criteria);
	},

	setReadWrite(field_criteria)
	{
		forEachField(this, field => field.setReadWrite(), field_criteria);
	},

	disableInputs(field_criteria)
	{
		forEachField(this, field => field.disableInput(), field_criteria);
	},

	enableInputs(field_criteria)
	{
		forEachField(this, field => field.enableInput(), field_criteria);
	},

	refresh(field_criteria)
	{
		forEachField(this, field => field.refresh(), field_criteria);
	},

	getValues()
	{
		let json = {};
		const callback = (field) =>
		{
			if (!field.isEmpty())
				json[field.getName()] = field.getValue();
		}
		forEachField(this, callback);
		return json;
	},

	setValues(values)		// { field_id: value, ... }
	{
		const callback = (field_id) =>
		{
			let key = Object.keys(this.fields).find(key => (new RegExp(`\\.${field_id}$`)).test(key));
			let field = this.fields[key];
			field?.setValue.call(field, values[field_id]);		// Some setValues() are overloaded, so let them handle this
		}
		Object.keys(values).forEach(field_id => callback(field_id));
	},

	eraseValues(field_criteria)
	{
		forEachField(this, field => field.eraseValue(), field_criteria);
	},

	checkErrorStates(field_criteria)
	{
		forEachField(this, field => field.checkErrorState(), field_criteria);
	},

	setErrorStates(state, field_criteria)
	{
		forEachField(this, field => field.setErrorState(state), field_criteria);
	},

	init()
	{
		this.captureFormEvents();
		this.captureFieldEvents();
		this.refresh();
	},

	/** Sincroniza valores do DOM para o armazenamento antes da validação (ex.: campo com foco ao clicar Salvar). Só para formulário #carrier. */
	syncFromDom()
	{
		const callback = (field) => { if (field.selector && typeof field.syncFromDom === 'function') field.syncFromDom(); };
		forEachField(this, callback);
	},

	check()
	{
		const callback = (field) =>
		{
			if (!field.isDisabled() && (field.isEmpty() && field.isRequired()) || (!field.isEmpty() && !field.checkValue()))
			{
				field.setErrorState(true);
				throw new Error(`Verificar ${field.getLabel()}`);
			}
		}
		Object.keys(this.fields).forEach(id => callback(this.fields[id]));
	},

	error(message)
	{
		this.checkErrorStates();
		this.setCursor(FIRST_ERROR);
		alert(message);
	},

	submit(ev)
	{
		try
		{
			//ev?.preventDefault();
			this.syncFromDom();
			this.check();
			this.callback?.(this.getValues());
		}
		catch (e)
		{
			this.error(e.message);
			console.log(e);
		}
	},

};

export { form as default, FIRST_ENABLED, FIRST_TEXT, FIRST_EMPTY, FIRST_ERROR };

